module.exports = __webpack_public_path__ + "img/img19.31a7515e.jpg";